<template>
  <div class='home-header'>
    <div class="header-item">
      <div class="item-company">
        {{headerName}}
      </div>
      <div class="item-switch" @click="handleSwitch"  v-if="!$route.query.sysusers_id">
        <img src="@/assets/images/switch.png" alt="">
        切换
      </div>
    </div>
    <action-sheet
      v-model="show_more_company"
      :actions="actions"
      cancel-text="取消"
      description="切换频道"
      close-on-click-action
      @select="handleSelect"
    />
  </div>	
</template>

<script>
    import {
        ActionSheet,
        Dialog
    } from 'vant'
    import Request from '@request'
    import api from '@api'
  export default {
  inject: ['reload'],
  components: {
    ActionSheet
  },
  data() {
    return {
      show_more_company: false,
      actions: [],
      headerName: ''
    };
  },
  
  computed: {},
  watch: {},
  created() {
    this.getList()
  },
  mounted() {
    this.getName(this.$route.query.sysusers_id)
  },
  methods: {
    handleSelect(item) {
      // window.location.href = `${window.location}?sysusers_id=${item.sysusers_id}`
      // this.reload()
      this.getName(item.sysusers_id)
      // this.getList()
    },
    handleSwitch() {
      this.show_more_company = true
    },
    getList() {
      Request.post(api.home.company_list).then(res => {
        console.log(res)
        res.data.map(item => {
          item.name = item.sysusers_name
        })
        this.actions = [{
          name: '医谱健康网',
          sysusers_id: '',
          sysusers_name: '医谱健康网'
        }, ...res.data]
        if(!this.$route.query.sysusers_id) {
          this.headerName = '医谱健康网'
          this.$emit('handleSelect', {})
        }
        
      })
    },
    getName(id) {
      Request.post(api.home.getcompayinfo, {
        sysusers_id: id
      }).then(res => {
        if(res.data.sysusers_lock == 1) {
          Dialog({
            message: '对不起，您访问的链接已失效！' ,
            showConfirmButton: false
          })
        }
          this.headerName = res.data.company
          this.$emit('handleSelect', res.data)        
      })        
    }
  },
}
</script>
<style scoped>
  .home-header {
    width: 100%;
    padding: 0 3.33%;
    box-sizing: border-box;
  }
  .header-item {
    width: 100%;
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-company {
    font-size: .73rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 45px;
  }
  .item-switch {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 0.51rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 40px;
  }
  .item-switch img {
    width: 0.75rem;
    height: 0.7rem;
    margin-right: .1rem;
  }
</style>
<style>
    .home-header .home-swipe .van-swipe-item {
        width: 100%;
        color: #fff;
        height: 5.5rem;
        text-align: center;
        background-color: #39a9ed;
    }

    .home-header .van-action-sheet__header {
        font-weight: bold;
        font-size: 0.73rem;
        color: #222222;
    }

    .home-header .van-action-sheet__close {
        color: black;
        font-size: 1rem;
    }

    /* 调节跟父组件宽度一致 */
    @media screen and (min-width: 581px) {
        .home-header .van-tabs__wrap {
            height: 64px !important;
        }

        .home-header .van-popup--bottom {
            margin-left: 0;
            max-width: 580px;
            width: 100%;
            left: auto;
            bottom: 0;
            overflow-x: hidden;
        }

        .home-header .van-action-sheet__header {
            line-height: 68px;
        }
    }
</style>